import React, { useState } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";

export default function CustomDialog({
  // open,
  // handleClose,
  // handleClickOpen,
  buttonText,
  bodyContent,
  onSubmit,
  buttonColor,
}) {
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Button color={buttonColor} variant="outlined" onClick={handleClickOpen}>
        {buttonText}
      </Button>
      {open && (
        <Dialog fullWidth maxWidth={"lg"} open={open} onClose={handleClose}>
          <DialogTitle></DialogTitle>
          <DialogContent>{bodyContent}</DialogContent>
          <DialogActions>
            <Button onClick={onSubmit} color="info">
              confirm
            </Button>{" "}
            <Button onClick={handleClose} color="error">
              Close
            </Button>
          </DialogActions>
        </Dialog>
      )}
    </>
  );
}
